import { mapGetters } from 'vuex'
import { EventBus } from '../plugins/event-bus.js'

export const shared = {
  methods: {
    validatePosts(posts) {
      // Check for invalid posts to inform an admin user, or splice them for public
      for (let i = posts.length - 1; i >= 0; i--) {
        if (
          posts[i].category === 3 &&
          (!posts[i].event_start_at || !posts[i].event_end_at)
        ) {
          if (!this.user) {
            posts.splice(i, 1)
          } else {
            posts[i].event_invalid = true
          }
        }
      }
      return posts
    },

    trackCurrentRoute(post) {
      window._paq.push(['setCustomUrl', location.href])
      window._paq.push(['setDocumentTitle', post.title])
      window._paq.push(['trackPageView'])
    },

    checkBrowser() {
      let badBrowser =
        navigator.vendor.match(/apple/i) &&
        !navigator.userAgent.match(/crios/i) &&
        !navigator.userAgent.match(/fxios/i) &&
        !navigator.userAgent.match(/Opera|OPT\//)

      if (badBrowser) {
        let bodytag = document.getElementsByTagName('body')[0]
        bodytag.dataset.badbrowser = 'badbrowser'
      }
    },

    /** WE want to lock the body with an overflow - hidden when the modal is active so that it does not scroll when targeted */
    setBodyLockModal(active) {
      let el = document.getElementsByTagName('body')[0]
      if (active) {
        el.classList.add('overflow-hidden')
      } else {
        if (el.classList.contains('overflow-hidden')) {
          el.classList.remove('overflow-hidden')
        }
      }
    },

    toggleRegistrationModal() {
      EventBus.$emit('modalRegisterShow')
    },

    /**
     *
     *
     *
     *  DOM screen helpers:
     * */

    scrollTo(target) {
      this.$scrollTo(target, 1000)
    },

    /**
     *
     *
     *
     * String helpers:
     * */
    randomStrId(length = 5) {
      let result = ''
      let characters =
        'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'
      let charactersLength = characters.length
      for (let i = 0; i < length; i++) {
        result += characters.charAt(
          Math.floor(Math.random() * charactersLength),
        )
      }
      return result
    },

    /**
     *  Form helpers
     *  @TODO remove/transfer/add to helper.js
     * */
    validateEmail(email) {
      let re =
        /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      return re.test(email)
    },

    validatePhoneNumber(number) {
      //  /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/im;
      //  /^(\((03|04|06|07|09)\)\d{7})|(\((021|022|025|027|028|029)\)\d{6,8})|((0508|0800|0900)\d{5,8})$/;
      //  /^((03|04|06|07|09)\d{5,7})|((021|022|025|027|028|029)\d{6,8})|((0508|0800|0900)\d{5,8})$/;
      //  /^([0]{1}[0-9]{2,9})$/;

      let valid_format = /^([0]{1}[0-9]{2,9})$/.test(number)
      if (!valid_format) {
        return false
      }
      return number.length > 10 || number.length < 9 ? false : true
    },

    // @TODO remove and use version in helper.js
    validateURL(str) {
      let pattern = new RegExp(
        '^(https?:\\/\\/)?' + // protocol
          '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' + // domain name
          '((\\d{1,3}\\.){3}\\d{1,3}))' + // OR ip (v4) address
          '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' + // port and path
          '(\\?[;&a-z\\d%_.~+=-]*)?' + // query string
          '(\\#[-a-z\\d_]*)?$',
        'i',
      ) // fragment locator
      return !!pattern.test(str)
    },

    // @TODO remove and use version in helper.js
    validateURLProtocol(url) {
      let hasprotocol = false
      if (url.indexOf('http://') === 0 || url.indexOf('https://') === 0) {
        hasprotocol = true
      }
      return hasprotocol
    },

    /** Determines if an image is the correct format and ile size... Initiates the event broadcast and returns a boolean */
    validateImageFormat(file) {
      let success = true

      let file_limit = 1024 * 1024 * 2 // 2mb
      let image_formats = /(\.png|\.jpg|\.jpeg|\.pdf)$/i

      let is_valid_file_format = image_formats.exec(file.name)
      let is_under_max_file_limit = file.size <= file_limit

      if (!is_valid_file_format || !is_under_max_file_limit) {
        let message = 'File size too large. 2mb file size limit exceeded.'
        if (!is_valid_file_format) {
          message = 'Image format is incorrect.'
        }
        EventBus.$emit('triggerAlertResponse', {
          status: 'error',
          message: message,
        })
        success = false
      }

      return success
    },

    // @TODO remove and use version in helper.js
    updateURLWithProtocol(url) {
      return 'https://' + url
    },

    /*** Make a random string number  */
    makeId() {
      let random_str = ''
      let possible =
        'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'
      for (let i = 0; i < 10; i++) {
        random_str += possible.charAt(
          Math.floor(Math.random() * possible.length),
        )
      }
      return random_str
    },

    submitInputOption(submitData = false, saving_model_name = false) {
      if (!submitData) {
        return
      }

      // Trigger the preloader event for this model.
      if (saving_model_name) {
        EventBus.$emit('saving_ui_model', {
          processing: true,
          model_name: saving_model_name,
        })
      }

      axios
        .post('/api/auth/manager/add-update-input', submitData)
        .then((response) => {
          // Kill the preloader event for this model.
          if (saving_model_name) {
            EventBus.$emit('saving_ui_model', {
              success: response.data.success,
              model_name: saving_model_name,
            })
          }

          if (response.data.success) {
            /** ... */
          } else {
            /** ... */
          }

          EventBus.$emit('reloadWebsiteSettings', 'shared2')
        })
    },
  },

  computed: {
    ...mapGetters({
      user: 'shared/getUser',
    }),
  },

  created() {
    window.addEventListener('resize', this.resizeEvent)
    this.resizeEvent
  },

  destroyed() {
    window.removeEventListener('resize', this.resizeEvent)
  },
}
